export enum TollVehicleType {
    CAR = "br.com.neolog.model.TollVehicleType.CAR",
    MOTORCYCLE = "br.com.neolog.model.TollVehicleType.MOTORCYCLE",
    TRUCK = "br.com.neolog.model.TollVehicleType.TRUCK"
}